var JoyChangeType;
(function (JoyChangeType) {
    JoyChangeType["added"] = "added";
    JoyChangeType["modified"] = "modified";
    JoyChangeType["removed"] = "removed";
})(JoyChangeType || (JoyChangeType = {}));
export default JoyChangeType;
//# sourceMappingURL=JoyChangeType.js.map